module.exports = __webpack_public_path__ + "static/media/check.f61a5b9a.svg";